import dayjs from "dayjs";
import _ from "lodash";

import { MonthlyCashflowResultTemplate } from "@/logics/monthlyCashflowResultTemplate";

import { MonthlyBalanceSheet } from "./balancesheetTypes";

export const MonthlyBalanceSheetPrototype: MonthlyBalanceSheet = {
  month: dayjs(),
  result: _.cloneDeep(MonthlyCashflowResultTemplate),
  price_of_properties: 0,
  price_of_loan: 0,
  property_acquisition_tax: 0,
  price_of_misc_expences_at_bought: 0,
  remaining_loan_amount: 0,
  simulated_sales_price: 0,
  cumulative_rent_income: 0,
  cumulative_misc_income: 0,
  cumulative_expence: 0,
  cumulative_misc_expence: 0,
  cumulative_repair_fund_cost: 0,
  cumulative_management_cost: 0,
  cumulative_bulding_management_cost: 0,
  cumulative_misc_cost: 0,
  cumulative_loan_payment: 0,
  cumulative_property_acquisition_tax: 0,
  cumulative_expences_at_buying: 0,
  cumulative_misc_expences_at_buying: 0,
  cumulative_outsourcing_fee_of_new_lease_contract: 0,
  cumulative_outsourcing_fee_of_updating_lease_contract: 0,
  cumulative_monthly_building_depreciation: 0,
  cumulative_monthly_facilities_depreciation: 0,
  selling_agent_fee: 0,
  stamp_tax: 0,
  misc_selling_expense: 0,
  capital_gain_tax: 0,
  sales_amount_by_selling: 0,
  loan_prepayment_by_selling: 0,
  expenses_by_selling: 0,
  cumulative_sales_amount_by_selling: 0,
  cumulative_loan_prepayment_by_selling: 0,
  cumulative_expenses_by_selling: 0,
  cumulative_real_estate_income_taxes: 0,
};
